(function () {
  const STORAGE_KEY = 'benis_preferred_pickup';

  function initStorePickup() {
    const modal = document.getElementById('pickupModal');
    if (!modal || modal.dataset.initialized === 'true') return;
    modal.dataset.initialized = 'true';

    const mapFrame = document.getElementById('pickupMapFrame');
    const items = [...modal.querySelectorAll('[data-pickup-item]')];
    const confirmBtn = modal.querySelector('[data-pickup-confirm]');
    const isDisabled = (item) => item.dataset.disabled === 'true';
    let selected = items.find((item) => item.classList.contains('is-active')) || items.find((item) => !isDisabled(item)) || items[0];

    function labels() {
      return document.querySelectorAll('[data-pickup-label]');
    }

    function updateLabel(name) {
      labels().forEach((el) => { el.textContent = name; });
      document.querySelectorAll('[data-cart-pickup]').forEach((el) => { el.hidden = false; });
    }

    function selectItem(item, { updateMap = true } = {}) {
      items.forEach((el) => {
        el.classList.toggle('is-active', el === item);
        el.setAttribute('aria-checked', el === item ? 'true' : 'false');
      });
      selected = item;

      if (updateMap && mapFrame) {
        const query = item.dataset.mapQuery || item.dataset.address;
        mapFrame.src = `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
      }
    }

    function openModal() {
      modal.showModal();
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.close();
      document.body.style.overflow = '';
    }

    async function clearPickup() {
      window.localStorage.removeItem(STORAGE_KEY);
      document.querySelectorAll('[data-cart-pickup]').forEach((el) => { el.hidden = true; });

      // Vuelve el selector del modal a su estado por defecto (primer punto
      // disponible), para que si lo reabren no quede marcado un punto que
      // ya no es la selección real — recién se vuelve a guardar si
      // confirman de nuevo.
      const fallback = items.find((item) => !isDisabled(item)) || items[0];
      if (fallback) selectItem(fallback, { updateMap: false });

      try {
        await window.BenisCart.updateAttributes({
          preferred_pickup_location: '',
          preferred_pickup_address: '',
        });
      } catch (err) {
        console.error('Pickup attribute clear error:', err);
      }
    }

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-pickup-open]')) openModal();
      if (e.target.closest('[data-pickup-clear]')) clearPickup();
    });

    modal.querySelector('[data-pickup-close]')?.addEventListener('click', closeModal);
    modal.addEventListener('close', () => { document.body.style.overflow = ''; });
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });

    items.forEach((item) => {
      if (isDisabled(item)) return;
      item.addEventListener('click', () => selectItem(item));
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectItem(item);
        }
      });
    });

    confirmBtn?.addEventListener('click', async () => {
      if (!selected) return;

      const name = selected.dataset.name;
      const address = selected.dataset.address;

      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ name, address }));
      updateLabel(name);

      confirmBtn.disabled = true;
      const original = confirmBtn.textContent;
      confirmBtn.textContent = 'Guardando…';

      try {
        await window.BenisCart.updateAttributes({
          preferred_pickup_location: name,
          preferred_pickup_address: address,
        });
      } catch (err) {
        console.error('Pickup attribute update error:', err);
      } finally {
        confirmBtn.disabled = false;
        confirmBtn.textContent = original;
        closeModal();
      }
    });

    // Restore previously saved selection, si existe y sigue disponible. Si el
    // visitante había guardado un punto que ahora está desactivado (ver
    // is-disabled en pickup-modal.liquid), se descarta ese valor guardado y
    // se deja el default (primer punto activo) en vez de forzar uno bloqueado.
    try {
      const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      if (saved && saved.name) {
        const match = items.find((item) => item.dataset.name === saved.name);
        if (match && !isDisabled(match)) {
          selectItem(match, { updateMap: false });
          updateLabel(saved.name);
        } else if (match && isDisabled(match)) {
          window.localStorage.removeItem(STORAGE_KEY);
        }
      }
    } catch (err) {
      // ignore malformed storage
    }
  }

  document.addEventListener('DOMContentLoaded', initStorePickup); document.addEventListener('DOMContentLoaded', function () { try { var p = new URLSearchParams(window.location.search); if (!p.has('retiro') && window.location.hash !== '#retiro') return; var w = p.get('retiro'); if (w) { document.querySelectorAll('[data-pickup-item]').forEach(function (el) { if (el.dataset.name === w && el.dataset.disabled !== 'true') el.click(); }); } var b = document.querySelector('[data-pickup-open]'); if (b) b.click(); } catch (e) {} });
  document.addEventListener('shopify:section:load', initStorePickup);
})();
